"use strict";

var __assign = void 0 && (void 0).__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __createBinding = void 0 && (void 0).__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);
  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
    desc = {
      enumerable: true,
      get: function () {
        return m[k];
      }
    };
  }
  Object.defineProperty(o, k2, desc);
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});
var __setModuleDefault = void 0 && (void 0).__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});
var __importStar = void 0 && (void 0).__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  __setModuleDefault(result, mod);
  return result;
};
var __rest = void 0 && (void 0).__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
var __importDefault = void 0 && (void 0).__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
var classnames_1 = __importDefault(require("classnames"));
var omit_js_1 = __importDefault(require("omit.js"));
var react_1 = __importStar(require("react"));
var Auto_1 = __importDefault(require("../Auto"));
var Fixed_1 = __importDefault(require("../Fixed"));
var FlexLayout_1 = __importStar(require("../FlexLayout"));
/**
 * LTCLayout
 * @param wrapClassName
 * @param wrapStyle
 * @param lProps
 * @param tProps
 * @param cProps
 * @param autoWrapProps
 * @param lSplit
 * @param tSplit
 * @param autoInnerProps
 * @param props
 * @param ref
 * @constructor
 */
var LTCLayout = (0, react_1.memo)((0, react_1.forwardRef)(function (_a, ref) {
  var _b;
  var wrapClassName = _a.wrapClassName,
    wrapStyle = _a.wrapStyle,
    autoWrapProps = _a.autoWrapProps,
    autoInnerProps = _a.autoInnerProps,
    lProps = _a.lProps,
    lSplit = _a.lSplit,
    tProps = _a.tProps,
    tSplit = _a.tSplit,
    cProps = _a.cProps,
    props = __rest(_a, ["wrapClassName", "wrapStyle", "autoWrapProps", "autoInnerProps", "lProps", "lSplit", "tProps", "tSplit", "cProps"]);
  // @ts-ignore
  var LProps = (0, omit_js_1.default)(lProps, ['children']);
  // @ts-ignore
  var TProps = (0, omit_js_1.default)(tProps, ['children']);
  // @ts-ignore
  var CProps = (0, omit_js_1.default)(cProps, ['children']);
  var classList = (0, react_1.useMemo)(function () {
    var _a;
    return (0, classnames_1.default)("".concat(FlexLayout_1.selectorPrefix, "-trblc"), (_a = {}, _a["".concat(FlexLayout_1.selectorPrefix, "-trblc-no-autofix")] = cProps && 'autoFixed' in cProps && !cProps.autoFixed, _a), wrapClassName !== null && wrapClassName !== void 0 ? wrapClassName : '');
  }, [cProps]);
  var autoWrapClassList = (0, react_1.useMemo)(function () {
    var _a;
    var _b;
    return (0, classnames_1.default)("".concat(FlexLayout_1.selectorPrefix, "-trblc-auto"), (_a = {}, _a["".concat(FlexLayout_1.selectorPrefix, "-trblc-auto-no-autofix")] = autoWrapProps && 'autoFixed' in autoWrapProps && !autoWrapProps.autoFixed, _a), (_b = autoWrapProps === null || autoWrapProps === void 0 ? void 0 : autoWrapProps.className) !== null && _b !== void 0 ? _b : '');
  }, [autoWrapProps]);
  var autoInnerClassList = (0, react_1.useMemo)(function () {
    var _a;
    var _b;
    return (0, classnames_1.default)("".concat(FlexLayout_1.selectorPrefix, "-trblc-auto-inner"), (_a = {}, _a["".concat(FlexLayout_1.selectorPrefix, "-trblc-auto-inner-no-autofix")] = autoInnerProps && 'autoFixed' in autoInnerProps && !autoInnerProps.autoFixed, _a), (_b = autoInnerProps === null || autoInnerProps === void 0 ? void 0 : autoInnerProps.className) !== null && _b !== void 0 ? _b : '');
  }, [autoInnerProps]);
  return react_1.default.createElement("div", {
    ref: ref,
    className: classList,
    style: wrapStyle !== null && wrapStyle !== void 0 ? wrapStyle : {}
  }, react_1.default.createElement(FlexLayout_1.default, __assign({}, props !== null && props !== void 0 ? props : {}, {
    className: (0, classnames_1.default)("".concat(FlexLayout_1.selectorPrefix, "-ltc-layout"), (_b = props === null || props === void 0 ? void 0 : props.className) !== null && _b !== void 0 ? _b : ''),
    direction: "horizontal"
  }), react_1.default.createElement(Fixed_1.default, __assign({
    collapseDirection: "L"
  }, LProps !== null && LProps !== void 0 ? LProps : {}), lProps === null || lProps === void 0 ? void 0 : lProps.children), lSplit, react_1.default.createElement(Auto_1.default, __assign({}, autoWrapProps !== null && autoWrapProps !== void 0 ? autoWrapProps : {}, {
    fit: false,
    className: autoWrapClassList
  }), react_1.default.createElement(FlexLayout_1.default, __assign({}, autoInnerProps !== null && autoInnerProps !== void 0 ? autoInnerProps : {}, {
    className: autoInnerClassList,
    direction: "vertical"
  }), react_1.default.createElement(Fixed_1.default, __assign({
    collapseDirection: "T"
  }, TProps !== null && TProps !== void 0 ? TProps : {}), tProps === null || tProps === void 0 ? void 0 : tProps.children), tSplit, react_1.default.createElement(Auto_1.default, __assign({}, CProps !== null && CProps !== void 0 ? CProps : {}), cProps === null || cProps === void 0 ? void 0 : cProps.children)))));
}));
LTCLayout.displayName = 'LTCLayout';
exports.default = LTCLayout;